import React from 'react';

export interface VoxelDividerProps {
  className?: string;
  color?: 'light' | 'medium';
}

export const VoxelDivider: React.FC<VoxelDividerProps> = ({ className, color = 'medium' }) => {
  return (
    <div
      className={`w-full h-0 border-t border-solid ${color === 'medium' && 'border-voxel-gray-200'}
      ${color === 'light' && 'border-voxel-gray-200/80'}
      ${className}`}
    />
  );
};

export default VoxelDivider;
